import { Card, Typography, CardContent, Grid2, useTheme, CardMedia } from "@mui/material";
import { WorkplaceBooking } from "../typings";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import CheckinCheckoutControls from "../checkin-checkout-controls.component";

type Props = {
  booking: WorkplaceBooking[];
  search: string;
  refetchCheckinInfo: () => void;
};

export function CheckinBookingCard({ booking, search, refetchCheckinInfo }: Readonly<Props>) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Grid2
      container
      sx={{ direction: "row", alignItems: "center", justifyContent: "flex-start" }}
      wrap={"wrap"}
    >
      <div>
        {booking.map(bookingEl => (
          <Card
            key={bookingEl.bookingId}
            sx={{ display: "flex", width: 450, margin: theme.spacing(2) }}
          >
            <div style={{ display: "flex", flexDirection: "column", padding: 15 }}>
              <CardContent sx={{ flex: "1 0 auto", padding: 0 }}>
                <Typography component="h5" variant="h5">
                  {bookingEl.locationName}
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  {"Date: " +
                    DateTime.fromISO(bookingEl.start)
                      .setZone(bookingEl.locationTimezone)
                      .toFormat("dd.MM.yyyy")}
                </Typography>
                <Grid2 container direction={"row"} justifyContent={"flex-start"}>
                  <Typography variant="subtitle1" color="textSecondary">
                    {t("Time")}
                  </Typography>
                  <Typography variant="subtitle1" color="textSecondary">
                    {": "}
                    {DateTime.fromISO(bookingEl.start)
                      .setZone(bookingEl.locationTimezone)
                      .toFormat("HH:mm")}{" "}
                    -{" "}
                    {DateTime.fromISO(bookingEl.end)
                      .setZone(bookingEl.locationTimezone)
                      .toFormat("HH:mm")}
                  </Typography>
                </Grid2>
              </CardContent>

              <CheckinCheckoutControls
                uid={search.substring(1)}
                alreadyCheckedIn={bookingEl.alreadyCheckedIn}
                bookingId={bookingEl.bookingId}
                end={bookingEl.end}
                locationInventoryId={bookingEl.locationInventoryId}
                start={bookingEl.start}
                locationTimezone={bookingEl.locationTimezone}
                bookingType={bookingEl.bookingType}
                refetchCheckinInfo={refetchCheckinInfo}
                checkinPeriod={bookingEl.checkinPeriod}
              />
            </div>

            <CardMedia
              sx={{ width: 151, marginLeft: "30px" }}
              image={bookingEl.locationPictureUrl}
              title={bookingEl.locationName}
            />
          </Card>
        ))}
      </div>
    </Grid2>
  );
}
